import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'Luster Adorn', 
  description = 'Discover exquisite imitation jewelry at Luster Adorn. Premium quality pieces at affordable prices.',
  image = '/logo.png',
  url,
  type = 'website',
  product = null 
}) => {
  const siteUrl = 'https://lusteradorn.com';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullTitle = title === 'Luster Adorn' ? title : `${title} | Luster Adorn`;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Luster Adorn" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Product specific schema */}
      {product && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            "name": product.name,
            "description": product.description,
            "image": product.image_urls?.[0] || image,
            "offers": {
              "@type": "Offer",
              "price": product.selling_rate,
              "priceCurrency": "INR",
              "availability": product.quantity > 0 
                ? "https://schema.org/InStock" 
                : "https://schema.org/OutOfStock"
            }
          })}
        </script>
      )}
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default SEO;
